import { render, staticRenderFns } from "./SewingComponent.vue?vue&type=template&id=5b647e62"
import script from "./SewingComponent.vue?vue&type=script&lang=js"
export * from "./SewingComponent.vue?vue&type=script&lang=js"
import style0 from "./SewingComponent.vue?vue&type=style&index=0&id=5b647e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports